import React, { useEffect, useState } from "react";
import { Container, Spinner, Table } from "react-bootstrap";
import {
  MdAddCircleOutline,
  MdOutlineEdit,
  MdOutlineCategory,
  MdOutlineDashboardCustomize,
  MdDeleteOutline,
} from "react-icons/md";
import { RiArrowUpDownFill } from "react-icons/ri";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { apiGetProcesses } from "../../api/ApiProcess";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import ModalCreateUpdate from "../../components/admin/process/ModalCreateUpdate";
import ModalChoixResponsables from "../../components/admin/process/ModalChoixResponsables";
import ModalDelete from "../../components/admin/process/ModalDelete";
import ModalDeleteView from "../../components/admin/view/ModalDeleteView";
import { selectReduxInstance } from "../../redux/ReduxInstance";
import { BiSubdirectoryRight } from "react-icons/bi";
import ModalOrdonner from "../../components/admin/process/ModalOrdonner";
import { useTranslation } from "react-i18next";

const PageAdminProcesses = () => {
  const { t } = useTranslation();
  const ReduxInstance = useSelector(selectReduxInstance);
  const [processes, setProcesses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showCreateUpdate, setShowCreateUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showDeleteView, setShowDeleteView] = useState(false);
  const [showOrgunits, setShowOrgunits] = useState(false);
  const [showOrdonnerProcess, setShowOrdonnerProcess] = useState(false);

  const [idProcess, setIdProcess] = useState("");
  const [idView, setIdView] = useState("");
  const navigate = useNavigate();

  const handleShowCreateUpdate = (id = null) => {
    setIdProcess(id);
    setShowCreateUpdate(true);
  };

  const handleShowDelete = (id) => {
    setIdProcess(id);
    setShowDelete(true);
  };

  const handleShowOrgunits = (id) => {
    setIdProcess(id);
    setShowOrgunits(true);
  };

  const handleCloseOrgunits = () => {
    setShowOrgunits(false);
  };

  const handleCloseOrdonner = () => {
    setShowOrdonnerProcess(false);
  };

  const recupProcesses = async () => {
    setLoading(true);
    const res = await apiGetProcesses(ReduxInstance._id, "sort[ordre]=-1");
    if (res) {
      setProcesses(res.data);
      setLoading(false);
    } else {
      setError("Une errer est survenue, veuillez réessayer ultérieurement");
      setLoading(false);
    }
  };

  const handleCloseCreateUpdate = () => {
    setIdProcess("");
    setShowCreateUpdate(false);
  };

  const handleCloseDelete = () => {
    setIdProcess("");
    setShowDelete(false);
  };

  const handleCloseDeleteView = () => {
    setIdView("");
    setShowDeleteView(false);
  };

  // const createView = async (process_id, process_nom) => {
  //   const res = await apiSaveView(
  //     ReduxInstance._id,
  //     process_nom,
  //     [],
  //     process_id
  //   );
  //   if (res) {
  //     navigate("/admin/easygouv/views/" + res.data._id + "/edit");
  //   } else {
  //     console.log("Error");
  //   }
  // };

  // const deleteView = async (view_id) => {
  //   setIdView(view_id);
  //   setShowDeleteView(true);
  // };
  const handleClick = (event, classToToggle, niveauProcessClic) => {
    const niveauAffichage = niveauProcessClic + 1;
    let allWithClass = [];
    let allButtonWithClass = [];

    if (event.currentTarget.classList.contains("plusDeplier")) {
      event.currentTarget.classList.remove("plusDeplier");
      event.currentTarget.classList.add("moinsReplier");
      allWithClass = Array.from(
        document.getElementsByClassName("process_" + classToToggle + " niveau_" + niveauAffichage)
      );
      allWithClass.map((item, index) => item.classList.remove("d-none"));
    } else {
      event.currentTarget.classList.remove("moinsReplier");
      event.currentTarget.classList.add("plusDeplier");
      allWithClass = Array.from(document.getElementsByClassName("process_" + classToToggle));
      allWithClass.map((item, index) => item.classList.add("d-none"));

      allButtonWithClass = Array.from(document.getElementsByClassName("button_" + classToToggle));
      allButtonWithClass.map((item, index) => {
        item.classList.remove("moinsReplier");
        item.classList.add("plusDeplier");
      });
    }
  };

  const toggleDeplierReplier = (event) => {
    const allTr = Array.from(document.getElementsByClassName("niveaux"));
    const allButtons = Array.from(document.getElementsByClassName("buttons"));

    if (event.currentTarget.classList.contains("plusDeplier")) {
      event.currentTarget.classList.remove("plusDeplier");
      event.currentTarget.classList.add("moinsReplier");
      allTr.map((item, index) => item.classList.remove("d-none"));
      allButtons.map((item, index) => {
        item.classList.add("moinsReplier");
        item.classList.remove("plusDeplier");
      });
    } else {
      event.currentTarget.classList.add("plusDeplier");
      event.currentTarget.classList.remove("moinsReplier");
      allTr.map((item, index) => item.classList.add("d-none"));
      allButtons.map((item, index) => {
        item.classList.remove("moinsReplier");
        item.classList.add("plusDeplier");
      });
    }
  };

  const RecursiveComponentLigneTableau = ({
    objet,
    detailView,
    niveau,
    arbreGenealogique,
    arbreGenealogiqueButton,
  }) => {
    let hasview = false;
    let enfantsIdentite = [];

    if (detailView.length > 0) {
      hasview = true;
      const bodyVue = detailView;

      // on cherche les process principaux de la vue
      const enfantsPrincipaux = [];
      for (const node of bodyVue) {
        if (node.data?.template === 0) {
          enfantsPrincipaux.push(node.data.process);
        }
      }

      // on cherche dans les processes quel est le nom ds process enfants
      enfantsPrincipaux.map((enfant) => {
        return enfantsIdentite.push(processes.find((element) => element._id === enfant));
      });
    }

    return (
      <>
        <tr
          className={
            niveau !== 0
              ? "niveaux d-none niveau_" + niveau + " " + arbreGenealogique
              : "niveau_" + niveau + " " + arbreGenealogique
          }
        >
          <td className="d-flex align-items-center">
            {niveau !== 0 && (
              <BiSubdirectoryRight
                size="2em"
                className="text-danger flecheSousProcess"
                style={{ marginLeft: niveau * 15 + "px" }}
              />
            )}
            {hasview && (
              <span
                className={"p-1 ms-1 me-2 buttons plusDeplier " + arbreGenealogiqueButton}
                onClick={(event) => handleClick(event, objet._id, niveau)}
              ></span>
            )}
            {objet.nom}
          </td>
          <td className="text-center">
            <MdOutlineCategory
              size="1.5em"
              role="button"
              onClick={() => handleShowOrgunits(objet._id)}
            />
          </td>
          <td className="text-center">
            <MdOutlineDashboardCustomize
              size="1.5em"
              role="button"
              onClick={() => navigate("/admin/easygouv/processes/" + objet._id + "/view")}
            />
          </td>
          <td className="text-center">
            <MdOutlineEdit
              size="1.5em"
              role="button"
              onClick={() => handleShowCreateUpdate(objet._id)}
            />
          </td>
          <td className="text-center">
            <MdDeleteOutline
              size="1.5em"
              role="button"
              onClick={() => handleShowDelete(objet._id)}
            />
          </td>
        </tr>
        {hasview &&
          enfantsIdentite.map((enfant, index) => (
            <RecursiveComponentLigneTableau
              key={index + "_" + enfant._id}
              objet={enfant}
              detailView={enfant.view}
              niveau={niveau + 1}
              arbreGenealogique={arbreGenealogique + " process_" + objet._id}
              arbreGenealogiqueButton={arbreGenealogiqueButton + "buttons button_" + objet._id}
            />
          ))}
      </>
    );
  };

  useEffect(() => {
    recupProcesses();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminProcesses.titre")} />
        <div className="d-flex justify-content-between">
          <span role="button" onClick={() => handleShowCreateUpdate()}>
            <MdAddCircleOutline size="1.5em" />{" "}
            {t("admin.PageAdminProcesses.buttonAjouterProcessus")}
          </span>
          {processes.filter((item) => item.famille === "MacroProcess").length > 1 && (
            <>
              <span role="button" onClick={() => setShowOrdonnerProcess(true)}>
                <RiArrowUpDownFill size="1.5em" /> {t("admin.PageAdminProcesses.buttonOrdonner")}
              </span>
            </>
          )}
        </div>
        {loading ? (
          <div style={{ textAlign: "center", flex: 1 }}>
            <Spinner animation="grow" />
          </div>
        ) : error ? (
          <div>{error}</div>
        ) : (
          <Table striped bordered hover className="stickyTable mt-2">
            <thead>
              <tr>
                <th className="d-flex align-items-center">
                  <span
                    className={"p-1 plusDeplier ms-1 me-2"}
                    onClick={toggleDeplierReplier}
                  ></span>
                  {t("admin.PageAdminProcesses.titreColonne1")}{" "}
                </th>
                <th className="text-center">{t("admin.PageAdminProcesses.titreColonne2")}</th>
                <th className="text-center">{t("admin.PageAdminProcesses.titreColonne3")}</th>
                <th className="text-center">{t("admin.PageAdminProcesses.titreColonne4")}</th>
                <th className="text-center">{t("admin.PageAdminProcesses.titreColonne5")}</th>
              </tr>
            </thead>
            <tbody>
              {processes
                .filter((item) => item.famille === "MacroProcess")
                .map((process) => (
                  <RecursiveComponentLigneTableau
                    key={process._id}
                    objet={process}
                    detailView={process.view}
                    niveau={0}
                    arbreGenealogique=""
                    arbreGenealogiqueButton=""
                  />
                ))}
            </tbody>
          </Table>
        )}

        <ModalOrdonner
          show={showOrdonnerProcess}
          handleRecupDatas={recupProcesses}
          macrosProcess={processes.filter((item) => item.famille === "MacroProcess")}
          handleClose={handleCloseOrdonner}
        />
        <ModalCreateUpdate
          show={showCreateUpdate}
          id={idProcess}
          handleClose={handleCloseCreateUpdate}
          handleRecupDatas={recupProcesses}
          forceMacro={true}
        />
        <ModalDelete
          show={showDelete}
          id={idProcess}
          handleClose={handleCloseDelete}
          handleRecupDatas={recupProcesses}
        />
        <ModalDeleteView
          show={showDeleteView}
          id={idView}
          handleClose={handleCloseDeleteView}
          handleRecupDatas={recupProcesses}
        />
        <ModalChoixResponsables
          show={showOrgunits}
          idProcess={idProcess}
          handleClose={handleCloseOrgunits}
          ReduxInstanceId={ReduxInstance._id}
        />
      </Container>
    </>
  );
};

export default PageAdminProcesses;
